import { axios_nomination } from '@/plugins/axios';
import configuration from '@/configurations';

const TIMEOUT_MS = 5000;

const withTimeout = (promise, default_value) => {
  const timeout = new Promise((resolve) =>
    setTimeout(() => resolve(default_value), TIMEOUT_MS)
  );

  return Promise.race([promise, timeout]);
};

class SocialSellingRepository {

  /**
   * @returns {Promise}
   */
  async getContactsForEntryPoints(user_id, account_id) {
    const result = await withTimeout(
      axios_nomination.get(
        `${configuration.api_host}/v1/graph/users/${user_id}/accounts/${account_id}/contacts`
      ),
      { data: [] }
    );

    return result.data;
  }

  async getContactsForIceBreakers(user_id, account_id) {
    const result = await withTimeout(
      axios_nomination.get(
        `${configuration.api_host}/v1/graph/users/${user_id}/accounts/${account_id}/ice-breakers`
      ),
      { data: [] }
    );

    return result.data;
  }
}

const social_selling_repository = new SocialSellingRepository();

export {
  social_selling_repository,
};
